$(document).ready(function () {
	document.querySelectorAll('.p-faq__inner.js-accordion dt').forEach(item => {
		item.addEventListener('click', function () {
			this.parentElement.classList.toggle('is-open');
		});
	});

	// アンカーリンクがクリックされた場合のイベントリスナーを追加
	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	    anchor.addEventListener('click', function (e) {
	        e.preventDefault(); // デフォルトの挙動を防止
	        const href = this.getAttribute('href'); // クリックされたアンカーのhref属性を取得
	        if (href.length > 1) { // hrefが'#'だけでないことを確認（つまり、実際のIDが存在する）
	            const targetId = href.substring(1); // 先頭の'#'を除去してIDを取得
	            const targetElement = document.getElementById(targetId); // 対象の要素を取得
	            if (targetElement) {
	                targetElement.classList.add('is-open'); // 対象のdivにis-openクラスを追加
	            }
	        }
	    });
	});

	var url_hash = location.hash;
	if (!$(url_hash).length) return;
	$(url_hash).addClass('is-open');

	// アンカーリンクスクロール
	let gap = $('header').height();
	let position = $(url_hash).offset().top - gap + 1;

	scrollTo(0, position);
});
